export const loadingLandingConfig = {
  pageLoading: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.logos/vlinder-logo.png',
    titleNormalText: 'Loading',
    titleBoldText: 'Page ...',
    description: 'This might take few seconds, Please wait !',
  },
};
